import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abcc65a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"left","margin":"0"} }, "Order items", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "card-catelog" }
const _hoisted_6 = { class: "card-price" }

import { Trash } from "@vicons/tabler";
import { NGrid, NGridItem, NIcon, NSpace, NInputNumber, NButton, NCard } from 'naive-ui'

import { useProductStore } from '@/stores/ProductStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartList',
  setup(__props) {

const store = useProductStore();

const clearCart = function () {
    store.cart.addedProducts = [];
}
const removeProduct = function (index: number) {
    store.cart.addedProducts.splice(index, 1);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(NGrid), {
    "x-gap": 12,
    "y-gap": 8,
    cols: "1"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NGridItem), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NSpace), { style: {"justify-content":"space-between"} }, {
            default: _withCtx(() => [
              _hoisted_1,
              (_unref(store).cart.addedProducts.length > 0)
                ? (_openBlock(), _createBlock(_unref(NButton), {
                    key: 0,
                    tertiary: "",
                    size: "medium",
                    "on-click": clearCart
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Clear cart ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(NGridItem), { style: {"text-align":"left"} }, {
        default: _withCtx(() => [
          (_unref(store).cart.addedProducts.length <= 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, " The cart is empty... "))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).cart.addedProducts, (product, index) => {
        return (_openBlock(), _createBlock(_unref(NGridItem), {
          key: product.name + '-' + index
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NCard), null, {
              cover: _withCtx(() => [
                _createElementVNode("img", {
                  style: {"box-sizing":"border-box"},
                  src: require(`@/assets/img/products/${product.image}`)
                }, null, 8, _hoisted_3)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_router_link, {
                    to: '/product/' + index
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_4, _toDisplayString(product.amount) + "x " + _toDisplayString(product.name + ((product.details === '') ? '' : ' - ' + product.details)), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("span", _hoisted_5, "#" + _toDisplayString(product.catelogId), 1),
                  _createElementVNode("p", _hoisted_6, _toDisplayString((typeof (product.price) === 'number') ?
                                '$ ' + (product.price / 100 * 75).toFixed(2).toString() + ',-' :
                                product.price), 1)
                ]),
                _createVNode(_unref(NInputNumber), {
                  style: {"width":"100px","text-align":"center","margin":"5px auto 0 auto"},
                  value: product.amount,
                  "onUpdate:value": ($event: any) => ((product.amount) = $event),
                  "button-placement": "both",
                  min: 1
                }, null, 8, ["value", "onUpdate:value"]),
                _createVNode(_unref(NButton), {
                  strong: "",
                  secondary: "",
                  circle: "",
                  size: "large",
                  onClick: ($event: any) => (removeProduct(index))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_unref(NIcon), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Trash))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})